var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-scrollbar',_vm._b({ref:"scrollbar",on:{"scroll":_vm.handleScroll}},'el-scrollbar',_vm.$props,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }